import type { ReactNode } from 'react';
import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

import { FieldGroup, TextField, TextInput } from '@gitbook/spine-react';

import { type LocalizationConfig, LocalizedTextField } from '../../Translations';
import { IconPickerField } from './IconPickerField';

export function TitleAndIconField<TFieldValues extends FieldValues>(props: {
    form: UseFormReturn<TFieldValues>;
    titleName: FieldPath<TFieldValues>;
    localizedTitleName?: FieldPath<TFieldValues>;
    iconName: FieldPath<TFieldValues>;
    children?: ReactNode;
    minLength: number;
    maxLength: number;
    disabled?: boolean;
    autoFocus?: boolean;
    localization?: LocalizationConfig;
    titleSuffix?: ReactNode;
    titleInputFooter?: ReactNode;
}) {
    const {
        minLength,
        maxLength,
        children,
        form,
        iconName,
        titleName,
        localizedTitleName,
        disabled,
        autoFocus,
        localization,
        titleSuffix,
        titleInputFooter,
    } = props;

    return (
        <FieldGroup>
            {children}
            <div className={`flex gap-2 ${titleInputFooter ? 'items-start' : 'items-center'}`}>
                <IconPickerField form={form} name={iconName} disabled={disabled} />
                <div className="min-w-0 flex-1">
                    {localizedTitleName ? (
                        <>
                            <LocalizedTextField
                                {...localization}
                                form={form}
                                name={titleName}
                                localizedName={localizedTitleName}
                                inputProps={{
                                    required: true,
                                    minLength,
                                    maxLength,
                                    disabled,
                                    autoFocus,
                                    placeholder: 'Enter title...',
                                    suffix: titleSuffix,
                                }}
                            />
                            {titleInputFooter}
                        </>
                    ) : (
                        <TextField
                            form={form}
                            name={titleName}
                            required
                            minLength={minLength}
                            maxLength={maxLength}
                        >
                            <TextInput
                                disabled={disabled}
                                autoFocus={autoFocus}
                                suffix={titleSuffix}
                            />
                            {titleInputFooter}
                        </TextField>
                    )}
                </div>
            </div>
        </FieldGroup>
    );
}
